import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys, type PlansListFilters } from '@/core/data-fetching/queryKeys';
import { plansService } from '../api/plans.service';

export function usePlansListQuery(filters: PlansListFilters) {
  return useQuery({
    queryKey: queryKeys.plans.list(filters),
    queryFn: () => plansService.list(filters),
    placeholderData: keepPreviousData,
  });
}
